import React from "react";
import styled from "styled-components";

const Footer = () => {
  return (
    <PageFooter>
      Copyright <span>2026</span> ©{" "}
      <a href="https://gophonebox.com/">PhoneBox</a>
    </PageFooter>
  );
};
const PageFooter = styled.p`
  text-align: center;
  font-size: 0.9rem;
  color: #3f444c;
  a {
    color: #3f444c;
    text-decoration: none;
  }
`;
export default Footer;
